import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlanningToolsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M13.835 10.414q.514-.369.967-.814M3.199 9.6q.451.446.967.817M7.875 4.025V2.623C7.875 2 8.379 1.497 9 1.497v0c.622 0 1.126.504 1.126 1.126v1.403"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 5.999,
			r: 2.251,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "m9.684 8.148 3.802 7.605h1.517v-3.001L11.172 5.09A2.43 2.43 0 0 0 9 3.748v0c-.92 0-1.76.52-2.171 1.342l-3.831 7.662v3.001h1.5l3.803-7.605"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M11.426 11.632a8.24 8.24 0 0 1-4.865-.006M8.963 5.999a.038.038 0 1 0 .075 0 .038.038 0 0 0-.075 0"
		})
	]
});
export default SvgPlanningToolsinline;
